"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SatisfactionScoreValue = exports.YesNoCtaValue = exports.ItemType = void 0;
var ItemType;
(function (ItemType) {
    ItemType["Cta"] = "cta";
    ItemType["YesNoCta"] = "yes-no-cta";
    ItemType["SatisfactionScore"] = "satisfation-score";
    ItemType["MultipleChoice"] = "multiple-choice";
    ItemType["FreeText"] = "free-text";
    ItemType["Heading"] = "heading";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var YesNoCtaValue;
(function (YesNoCtaValue) {
    YesNoCtaValue["Yes"] = "yes";
    YesNoCtaValue["No"] = "no";
})(YesNoCtaValue = exports.YesNoCtaValue || (exports.YesNoCtaValue = {}));
var SatisfactionScoreValue;
(function (SatisfactionScoreValue) {
    SatisfactionScoreValue["Happy"] = "HAPPY";
    SatisfactionScoreValue["Unhappy"] = "UNHAPPY";
    SatisfactionScoreValue["Neutral"] = "NEUTRAL";
})(SatisfactionScoreValue = exports.SatisfactionScoreValue || (exports.SatisfactionScoreValue = {}));
//# sourceMappingURL=groupSessionFeedback.js.map